import React from 'react';

export const MAX_RQST_CNT = 10;   //최대 동시 진행가능 견적수 (global constant로 사용)
export const MAX_PROD = 30;    // 최대 요청할수 있는 상품수
export const MIN_ITEM = 2;     // 최소 견적요청 상품수
export const MAX_CLIP = 500;   // 최대 찜 수

export const MAX_CART_PERIOD = "1개월";   // 장바구니 보관기한
export const MAX_CART_CNT = 300;    // 장바구니 최대갯수
